import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0bd3c773"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "aigame-rules" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "aigame-rules-title" }, "赛制规则", -1))
const _hoisted_3 = { class: "aigame-rules-box" }
const _hoisted_4 = {
  key: 0,
  class: "aigame-rules-box__con"
}
const _hoisted_5 = { class: "aigame-rules-box__con--title" }
const _hoisted_6 = { class: "aigame-rules-box__con--subtitle" }
const _hoisted_7 = { class: "aigame-rules-box__con--tips" }
const _hoisted_8 = { class: "aigame-rules-box__con--title" }
const _hoisted_9 = { class: "aigame-rules-box__con--text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      (_ctx.activeTab === 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.contestants.title), 1),
            _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.contestants.subTitle), 1),
            _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.contestants.tips), 1),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.ruleItem, (item, index) => {
              return (_openBlock(), _createElementBlock("div", { key: index }, [
                _createElementVNode("div", _hoisted_8, _toDisplayString(item.title), 1),
                _createElementVNode("div", _hoisted_9, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.text, (rule, ind) => {
                    return (_openBlock(), _createElementBlock("div", { key: ind }, _toDisplayString(rule), 1))
                  }), 128))
                ])
              ]))
            }), 128))
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}